/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import ContentHubForm from './ContentHubForm.vue';
import EventProgress from 'ui/components/modals/EventProgress.vue';

/**
 * This component is used to create a new content hub.
 *
 * @exports CreateContentHub
 * @component
 */
const __vue_script__ = {
    name: 'CreateContentHub',

    components: { ContentHubForm, EventProgress },

    data() {
        return {
            error: null,
            form: {},
            disableSaveButton: true,
            trackingId: null,
            progress: 0,
            showProgress: false
        };
    },

    methods: {
        /**
         * Submits data to create the content hub with gathered information.
         */
        async submitForm() {
            try {
                // prevent multiple submits
                this.disableSaveButton = true;

                const payload = {
                    name: this.form.name,
                    organization: this.form.organization._id,
                    legal_documents: this.form.legal_documents.map(d => d._id),
                    brandedApp: this.form.container_app.fp_ext_id,
                    serverGroup: this.form.servers_location.value
                };

                const categoryEnabled = get(this.form, 'organization.workspace_defaults.enable_category', false);

                if (categoryEnabled) {
                    payload.category = this.form.category;
                    payload.categories = this.form.categories;
                }

                await this.$track('content_hub_creation', payload);

                const { data: { id, jobId, node } } = await this.$services.contentHub.create(this.form.organization.name, payload);

                this.$utils.modals.toMediumModal(this.$el);
                this.showProgress = true;

                if (!jobId || !id || !node) {
                    // Something went wrong, stop here.
                    console.error("[CreateContentHub] Can't register the job.");
                    this.setError('content_hubs.creation.errors.job_registration');
                    return;
                }

                const jobProgressUrl = this.$utils.url.getBackstageURL(node, this.$const.CREATE_WORKSPACE_QUEUE_JOB_RESULT_PATH);

                const minutesToTimeout = 15, interval = 1500;
                await this.$services.jobs.waitFor({
                    jobId,
                    statusPath: jobProgressUrl,
                    resultPath: jobProgressUrl,
                    updateUIProgress: progress => this.progress = progress,
                    interval, minutesToTimeout
                });

                this.reset();
                const contentHubUrl = this.$services.contentHub.getUrl(id, node);
                this.$router.redirect(contentHubUrl);

            } catch (error) {
                console.error('[CreateContentHub] Could not create content hub', error);
                this.$services.crashReporting.captureException(error);
                this.setError((error || {}).error || 'content_hubs.creation.errors.failure');
            } finally {
                this.disableSaveButton = false;
            }
        },

        /**
         * Sets the error and displays it to the user.
         *
         * @param {String} error the eventual occurred error.
         */
        setError(error) {
            this.$utils.modals.toSmallModal(this.$el);
            this.error = error;
            this.$track('content_hub_creation', error);
        },

        /**
         * Resets the component to its initial state and closes the modal.
         */
        reset() {
            this.error = null;
            this.form = {};
            this.trackingId = null;

            this.$emit('close');
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-content-hub"},[(!_vm.error && !_vm.showProgress)?_c('div',{staticClass:"create-form modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.reset()}}}),_c('h1',[_vm._v(_vm._s(_vm.$t('content_hubs.creation.main_title')))])]),_c('div',{staticClass:"modal-body"},[_c('content-hub-form',{on:{"data":function (data) { return _vm.form = data; },"validity":function (valid) { return _vm.disableSaveButton = !valid; }}})],1),_c('div',{staticClass:"modal-footer"},[_c('footer',{staticClass:"actions",attrs:{"slot":"bottom"},slot:"bottom"},[_c('button',{staticClass:"btn primary",attrs:{"disabled":_vm.disableSaveButton},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v(_vm._s(_vm.$t('content_hubs.creation.action')))])])])]):_vm._e(),(!_vm.error && _vm.showProgress)?_c('event-progress',{attrs:{"progress":_vm.progress,"title":_vm.$t('content_hubs.creation.creation_title')}}):_vm._e(),(_vm.error)?_c('div',{staticClass:"errors modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('h3',[_vm._v(_vm._s(_vm.$t('general.something_wrong')))])]),_c('div',{staticClass:"modal-body"},[(_vm.error.length !== 0)?_c('p',[_vm._v(_vm._s(_vm.$t('general.error_occurred'))+":")]):_vm._e(),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.error))}}),_c('p',[_vm._v(_vm._s(_vm.$t('general.try_later')))])]),_c('div',{staticClass:"modal-footer"},[_c('footer',{staticClass:"actions",attrs:{"slot":"bottom"},slot:"bottom"},[_c('button',{staticClass:"btn primary",on:{"click":function($event){return _vm.reset()}}},[_vm._v(_vm._s(_vm.$t('general.close')))])])])]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CreateContentHub.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__